module.exports = __webpack_public_path__ + "img/23.9562688c.png";